module.exports = __webpack_public_path__ + "static/media/bg17.3afae97c.jpg";